import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';

import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})

export class NewsletterService {

  constructor(
    public restful: RestfulService
  ) {
  }

  // 매거진 가져오기
  setUnsubscribe( form: any ): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'newsletter',
        version: '1.0',
        action: 'setUnsubscribe'
      }, form.value
    ).then( response => {
      return response || [];
    })
     .catch(this.restful.handleErrorPromise);
  }
}
